import React from 'react';
import { Button } from '@mui/material';
import { DeleteOutline, WarningAmberOutlined } from '@mui/icons-material';

import styles from './DangerZone.module.scss';

interface DangerZoneProps {
  actionError: string | null;
  isDeleting: boolean;
  onDelete: () => void;
  onClearError: () => void;
}

export function DangerZone({ actionError, isDeleting, onDelete, onClearError }: DangerZoneProps) {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <span className={styles.headerIcon}>
          <WarningAmberOutlined fontSize="small" />
        </span>
        <h2 className={styles.headerTitle}>Danger Zone</h2>
      </div>
      <div className={styles.body}>
        {actionError ? <span className={styles.errorMessage}>{actionError}</span> : null}

        <div className={styles.row}>
          <div>
            <h3 className={styles.rowTitle}>Delete Capsule</h3>
            <span className={styles.rowDescription}>
              Permanently remove this capsule. This action cannot be undone.
            </span>
          </div>
          <Button
            variant="outlined"
            color="error"
            startIcon={<DeleteOutline />}
            className={styles.deleteBtn}
            disabled={isDeleting}
            onClick={() => {
              onClearError();
              onDelete();
            }}
          >
            Delete
          </Button>
        </div>
      </div>
    </div>
  );
}
